import { useTranslation } from 'next-i18next';
import Icon from '../common/Icon';
import { useState } from 'react';
import { TABLE_LICENSES, TABLE_LICENSES_MOBILE } from '../../constant';

const DetailedLicenses = () => {
  const { t } = useTranslation();
  const TABLE_HEADER = [
    'prices_table_features',
    'prices_table_crypto',
    'prices_table_full',
    'prices_table_player',
  ];

  const [showMore, setShowMore] = useState(false);

  return (
    <div id="compare" className="detailed-main-wrapper">
      <div className="detailed">
        <div className="detailed-title">{t('prices_detailed_comparison')}</div>
        <div className="detailed-wrap">
          <div className="detailed-header-table">
            {TABLE_HEADER.map((index) => (
              <span key={index} className="item">
                {t(`${index}`)}
              </span>
            ))}
          </div>
          <div className="detailed-table">
            {TABLE_LICENSES.map((item) => (
              <div key={item.id} className="table-item">
                <div className="text-wrap">
                  <span className="title">{t(`${item.title}`)}</span>
                  <span className={showMore ? 'subTitleFull' : 'subTitle'}>
                    {t(`${item.subTitle}`)}
                    <br />
                    {item.subTitle2 && (
                      <>
                        <br /> {t(`${item.subTitle2}`)}
                      </>
                    )}{' '}
                    {/*{item.subTitleItem && (*/}
                    {/*  <a href="#" className="subTitleItem">*/}
                    {/*    {t(`${item.subTitleItem}`)}{' '}*/}
                    {/*    <Icon width={20} height={20} file="sprite" name="redirect" />*/}
                    {/*  </a>*/}
                    {/*)}*/}
                  </span>
                  {item.more && (
                    <span
                      onClick={() => setShowMore(!showMore)}
                      className={showMore ? 'show-less' : 'show-more'}
                    >
                      {showMore ? t('prices_table_less') : t('prices_table_more')}
                      <Icon width={1.5} height={1.5} file="sprite" name="arrow-down" />
                    </span>
                  )}
                </div>
                <div className="icon-wrap">
                  <Icon width={1.5} height={1.5} file="sprite" name={item.cryptoIcon.icon} />
                  {item.cryptoIcon.text && (
                    <span className="icon-text">{t(`${item.cryptoIcon.text}`)}</span>
                  )}
                </div>
                <div className="icon-wrap">
                  <Icon width={1.5} height={1.5} file="sprite" name={item.fullIcon} />
                </div>
                <div className="icon-wrap">
                  <Icon width={1.5} height={1.5} file="sprite" name={item.playerIcon} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="detailed-mobile">
        <div className="detailed-title">{t('prices_detailed_comparison')}</div>
        <div className="detailed-wrap">
          <div className="detailed-table">
            {TABLE_LICENSES_MOBILE.map((item) => (
              <div key={item.id} className="table-item">
                <div className="text-wrap">
                  <span className="title">{t(`${item.title}`)}</span>
                  <div className={showMore ? 'subTitleFull' : 'subTitle'}>
                    {t(`${item.subTitle}`)}
                    <br />
                    {item.subTitle2 && (
                      <>
                        <br /> {t(`${item.subTitle2}`)}
                      </>
                    )}{' '}
                    {/*{item.subTitleItem && (*/}
                    {/*  <a href="#" className="subTitleItem">*/}
                    {/*    {t(`${item.subTitleItem}`)}{' '}*/}
                    {/*    <Icon width={20} height={20} file="sprite" name="redirect" />*/}
                    {/*  </a>*/}
                    {/*)}*/}
                  </div>
                  {item.more && (
                    <span
                      onClick={() => setShowMore(!showMore)}
                      className={showMore ? 'show-less' : 'show-more'}
                    >
                      {showMore ? t('prices_table_less') : t('prices_table_more')}
                      <Icon width={1.5} height={1.5} file="sprite" name="arrow-down" />
                    </span>
                  )}
                </div>
                <div className="icons-wrap">
                  <div className="icon-wrap">
                    <Icon width={1.5} height={1.5} file="sprite" name={item.cryptoIcon.icon} />
                    <span className="icon-text">{t(`${item.cryptoIcon.text}`)}</span>
                  </div>
                  <div className="icon-wrap">
                    <Icon width={1.5} height={1.5} file="sprite" name={item.fullIcon.icon} />
                    <span className="icon-text">{t(`${item.fullIcon.text}`)}</span>
                  </div>
                  <div className="icon-wrap">
                    <Icon width={1.5} height={1.5} file="sprite" name={item.playerIcon.icon} />
                    <span className="icon-text">{t(`${item.playerIcon.text}`)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedLicenses;
